import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconEdit } from "../../../../../../assets/images/ActiveLearning/icon_edit.svg";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          発表するための資料を参考に、発表の準備をしよう。
        </p>
      </div>
      {question1 && (
        <div className={clsx(styles.question, styles.primary)}>
          <div className={styles.themEntry}>
            <p className={styles.title}>「問い」/その「問い」を立てた理由</p>
            <p className={styles.read}>
              設定した「問い」とその「問い」を立てた理由が表示されます。
            </p>
            <ul className={styles.pastAnswerList}>
              <li className={styles.pastAnswer}>
                回答データがありません。
                <IconEdit className={styles.editButton} />
              </li>
            </ul>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>「課題」/その「課題」を設定した理由</p>
            <p>
              「問い」に答えを出すための「課題」とその「課題」を設定した理由が表示されます。
            </p>
            <ul className={styles.pastAnswerList}>
              <li className={styles.pastAnswer}>
                回答データがありません。
                <IconEdit className={styles.editButton} />
              </li>
            </ul>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>
              解決のアイデア/そのアイデアに決めた理由
            </p>
            <p className={styles.read}>
              解決のアイデアとそのアイデアに決めた理由が表示されます。
            </p>
            <ul className={styles.pastAnswerList}>
              <li className={styles.pastAnswer}>
                回答データがありません。
                <IconEdit className={styles.editButton} />
              </li>
              <li className={styles.pastAnswer}>
                回答データがありません。
                <IconEdit className={styles.editButton} />
              </li>
              <li className={styles.pastAnswer}>
                回答データがありません。
                <IconEdit className={styles.editButton} />
              </li>
            </ul>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>
              解決のアイデアを実現するまでのステップ
            </p>
            <p className={styles.read}>
              解決のアイデアを実現するために考えたステップが表示されます。
            </p>
            <div className={clsx(styles.tree, styles.past)}>
              <p className={styles.answerList}>
                回答データがありません。
                <IconEdit className={styles.editButton} />
              </p>
            </div>
          </div>
          <div className={styles.themEntry}>
            <p className={styles.title}>{question1.title}</p>
            <p className={styles.read}>
              考えをまとめたり、伝わりやすくするためのメモを入力しよう。
            </p>
            <div className={styles.textAreaWrapper}>
              <TextArea />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue1Material;
